import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { RankingObject } from '@shared/models/recurring-ranking.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RecurringRankigService {
  private recurringRankingServiceUrl = 'api/trophy';

  private readonly http = inject(HttpClient);

  getRecurringRanking(): Observable<RankingObject> {
    return this.http.get<RankingObject>(`${environment.apiUrl}/${this.recurringRankingServiceUrl}/get-ranking`);
  }
}
